import type { CardDef } from "../types";
import type { IntakeData } from "@/lib/types";
import ResponsivePhotoCapture from "@/components/intake/dentist/ResponsivePhotoCapture";
import { useIntakeMobileChromeRegistration } from "../IntakeMobileChromeContext";

interface DentalPhotosCardProps {
  card: CardDef;
  data: IntakeData;
  onUpdate: (data: Partial<IntakeData>) => void;
  onNext: () => void;
  onBack: () => void;
  index: number;
}

export function DentalPhotosCard({
  data,
  onUpdate,
  onNext,
  onBack,
}: DentalPhotosCardProps) {
  useIntakeMobileChromeRegistration(
    () => ({
      onCancel: onBack,
      showContinue: false,
    }),
    [onBack],
  );

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col animate-in fade-in zoom-in-95 duration-300">
      <div className="mx-auto min-h-0 w-full max-w-5xl flex-1">
        <ResponsivePhotoCapture
          data={data}
          onUpdate={onUpdate}
          onNext={onNext}
          onBack={onBack}
          mobileBackUsesStickyFooter
        />
      </div>
    </div>
  );
}
